export const PRODUCT_SALE_STATUS = {
  Pending: 'pending',
  Completed: 'completed',
  Voided: 'voided',
};

export const getProductSaleStatusKey = (value) => {
  const key = String(value || '').toLowerCase();
  if (key === 'voided' || value === 3) {
    return PRODUCT_SALE_STATUS.Voided;
  }
  if (key === 'pending' || value === 1) {
    return PRODUCT_SALE_STATUS.Pending;
  }
  return PRODUCT_SALE_STATUS.Completed;
};

const CHIP_SX_BY_STATUS = {
  [PRODUCT_SALE_STATUS.Completed]: { backgroundColor: '#e8f5e9', color: '#2e7d32' },
  [PRODUCT_SALE_STATUS.Voided]: { backgroundColor: '#ffebee', color: '#c62828' },
  [PRODUCT_SALE_STATUS.Pending]: { backgroundColor: '#fff8e1', color: '#f57c00' },
};

export const getProductSaleStatusChipSx = (value) => ({
  fontWeight: 600,
  flexShrink: 0,
  ...CHIP_SX_BY_STATUS[getProductSaleStatusKey(value)],
});
